<template>
  <div>
    <h1>Redirecting...</h1>
    <p>
      If you are not redirected, please <a :href="redirectUrl">click here</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: "RedirectPage",
  data() {
    return {
      redirectUrl: "https://status.walkertracker.com/"
    };
  },
  mounted() {
    window.location.href = this.redirectUrl;
  }
};
</script>
